import { format } from 'date-fns';

export const formatDate = (dateString: string) => {
  return dateString ? format(new Date(dateString), 'yyyy.MM.dd') : '';
};

export const pad = (context: number) => {
  return context > 10 ? context : '0' + context;
};
